import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

//Models
import { Url } from '../models/url.model';
import { SearchModel } from '../models/search.model';

@Injectable()
export class SearchProvider {

  public headers: Headers;
  public options: RequestOptions;
  public urlUser = new Url;
  public urlCongresso = new Url;
  public params = new URLSearchParams();

  constructor(public http: Http,
                private jsonp: Jsonp,
                public configProvider: ConfigProvider) {
        this.urlCongresso = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlCongresso.SgunAuthorization, 'MobileReferer': this.urlCongresso.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
  }

  getSearch(guidUsuario, congressoAno):Promise<SearchModel> {
        this.params.set('guidUsuario', guidUsuario);
        this.params.set('congressoAno', congressoAno);
        return this.jsonp.get(this.urlCongresso.Cientifico + '/shared/apc/getSearchResult.ashx', {search: this.params })
                .map(res => res.json().resposta.retorno as SearchModel).toPromise()
   }

}



// WEBPACK FOOTER //
// ./src/providers/search-provider.ts